/**
 * Browser client for the Become a Partner form (COM-737) — the only file in
 * this module that calls `fetch`. A plain `fetch`, not a `useFetcher` submit,
 * for the same reason as Contact Us: a successful fetcher action revalidates
 * every loader on the (Builder) page. Never throws.
 */
import { upstreamSignal } from "~/utils/upstream-timeouts";

import {
  PARTNER_FORM_ENDPOINT,
  buildPartnerFormBody,
  parsePartnerFormResult,
} from "./partner-form.logic";
import type { PartnerFormResult, PartnerFormValues } from "./types";

export async function submitPartnerForm(
  values: PartnerFormValues,
): Promise<PartnerFormResult> {
  let response: Response;
  try {
    response = await fetch(PARTNER_FORM_ENDPOINT, {
      method: "POST",
      credentials: "same-origin",
      cache: "no-store",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: buildPartnerFormBody(values).toString(),
      signal: upstreamSignal("partner-form"),
    });
  } catch {
    return { ok: false, reason: "unavailable" };
  }
  const json: unknown = await response.json().catch(() => null);
  return parsePartnerFormResult(json);
}
